<template>
    <div class="flex flex-col items-center justify-center place-self-center "
        style="background-color: white; height: 700px; border-radius: 10px; width: 90%;">
        <div class="flex flex-col items-center justify-center place-self-center w-full" @dragover.prevent
            @drop.prevent="handleDrop">
            <img :src="require('@/assets/file-upload-icon.png')" alt="Upload Icon"
                style="width: 120px; height: 130px; margin: 10px;" />
            <p class="m-1">Drag and drop a file here to verify its contents</p>
            <p class="font-light text-xs m-1" style="color: grey;">Upload only .pdf file</p>
            <el-upload :show-file-list="false" accept=".pdf" :before-upload="handleBeforeUpload"
                :on-change="handleFileChange" class="m-1">
                <el-button type="primary" size="mini" plain :disabled="disabled">
                    Upload Attachment
                </el-button>
            </el-upload>
        </div>
    </div>
</template>

<script>
import { getServerUrl } from "@/utils/getServerUrl";
import axios from "axios";
export default {
    name: "verification",
    data() {
        return {
            uploadedFile: null
        };
    },
    methods: {
        async uploadAndValidate(file) {
            const form = new FormData();
            form.append("file", file);

            const response = await axios.post(
                `${getServerUrl()}/holdingCert/validateUploadedPdf`,
                form,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const result = response.data?.data;

            if (result?.certId) {
                this.$message.success("The PDF file is valid.");
                this.$store.commit("setUploadedFile", file);
                this.$router.push({
                    name: "ViewDoc", query: {
                        id: result.certId,
                        generateTime: result.generatedDatetime
                    }
                });
            } else {
                this.$message.error("The PDF file is invalid or has been modified.");
            }
        },

        async handleDrop(e) {
            const file = e.dataTransfer.files[0];
            if (!file || file.type !== "application/pdf") {
                this.$message.error("Please upload a valid PDF file.");
                return;
            }
            await this.uploadAndValidate(file);
        },

        async handleFileChange(uploadFile) {
            const file = uploadFile.raw;

            if (!file || file.type !== "application/pdf") {
                this.$message.error("Please upload a valid PDF file.");
                return
            }

            await this.uploadAndValidate(file);
        },

        handleBeforeUpload() {
            return false;
        }
    }
};
</script>

<style scoped></style>